import clsx from "clsx";

interface ChipProps {
  text: string;
  loading?: boolean;
  className?: string;
  color?: string;
  onClick?: () => void;
}

export default function Chip(props: ChipProps): JSX.Element {
  const { text, loading = false, className = "", color } = props;
  const { onClick } = props;
  const loadingClass = loading ? "loading" : "";

  return (
    <div
      className={clsx(
        "chip fade-loading px-2 py-1 text-sm rounded-md",
        loadingClass,
        className,
        color || "bg-secondary-50",
        { "text-secondary-600": !color }
      )}
      title={text}
      style={{ textOverflow: "ellipsis" }}
      onClick={onClick}
    >
      {text}
    </div>
  );
}
